/**
 * Successor Claim — Loading / Error / Thank-you full-page screens.
 * Extracted to keep SuccessorClaimUpload under the 200-LOC frontend function gate.
 */
import React from 'react';
import { Loader2, AlertCircle, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const ClaimLoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center text-slate-600">
    <Loader2 className="w-5 h-5 animate-spin mr-2" /> Loading your secure page&hellip;
  </div>
);

export const ClaimErrorScreen = ({ error, onReturn }) => (
  <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
    <div
      className="max-w-md bg-white rounded-2xl shadow-sm border border-slate-200 p-6 text-center"
      data-testid="succ-claim-error"
    >
      <AlertCircle className="w-10 h-10 text-rose-600 mx-auto mb-3" />
      <h2 className="text-lg font-semibold text-slate-900 mb-1">This link can&rsquo;t be opened</h2>
      <p className="text-sm text-slate-600 mb-4">{error}</p>
      <Button variant="outline" onClick={onReturn} data-testid="succ-claim-error-return">
        Return to MyInvestFolio
      </Button>
    </div>
  </div>
);

export const ClaimThankYouScreen = () => (
  <div className="min-h-screen bg-linear-to-br from-emerald-50 via-white to-slate-50 flex items-center justify-center px-4 py-12">
    <div
      className="max-w-2xl w-full bg-white rounded-2xl shadow-xl border border-slate-200 p-6 sm:p-10"
      data-testid="succ-claim-thankyou"
    >
      <CheckCircle2 className="w-12 h-12 text-emerald-600 mx-auto mb-4" />
      <h1 className="text-2xl font-bold text-slate-900 text-center mb-3">Submitted</h1>
      <p className="text-sm text-slate-700 leading-relaxed text-center max-w-md mx-auto">
        Thank you. Two members of our team will independently review your documents.
        We aim to respond within 5 business days. You will receive an email once the
        review is complete.
      </p>
      <div className="border border-emerald-100 bg-emerald-50/40 rounded-lg p-4 mt-6 text-xs text-slate-700 leading-relaxed">
        <strong>What happens next?</strong>
        <ol className="list-decimal pl-5 mt-2 space-y-1">
          <li>Two of our staff members will independently review what you uploaded.</li>
          <li>If we have any questions, we will email you directly. Please reply promptly.</li>
          <li>Once both reviewers approve, the Continuity Records will be shared with you securely.</li>
          <li>If we cannot verify the documents, we will let you know why and what to do next.</li>
        </ol>
      </div>
    </div>
  </div>
);
